import BaseSetup from '@/components/BaseSetup';
import OrganizationRoleDetailEntity from '@/entity/OrganizationRoleDetailEntity';
import type TagDetailEntity from '@/entity/TagDetailEntity';
import { Reactive } from '@/utils/decorators';
import { } from 'vue';

export type SharedUserListForRolesAndTagsEmits = {
	(e: 'showHiddenUsers', val: boolean): void
};

export type SharedUserListForRolesAndTagsProps = {
	users?: Armado.UserForRolesAndTags[]
	tag?: TagDetailEntity
	role?: OrganizationRoleDetailEntity
};

export default class SharedUserListForRolesAndTagsSetup extends BaseSetup {

	static readonly defaultProps = {
		users: () => [],
		tag: undefined,
		role: undefined,
	};

	@Reactive private readonly state = {
		search: undefined as Undef<string>,
		showHiddenUser: false,
	};

	constructor (
		private props: SharedUserListForRolesAndTagsProps,
		private emits: SharedUserListForRolesAndTagsEmits,
	) {
		super();
	}

	get search () { return this.state.search }
	set search (val) { this.state.search = val }

	get showHiddenUser () { return this.state.showHiddenUser }
	set showHiddenUser (val) { this.state.showHiddenUser = val }

	getHiddenUserTooltip (user: Armado.UserForRolesAndTags) {
		if (!user.hasAccessToArmado && user.isEnabledForSuite) return this.$t('auth.user.tooltip.noArmadoAccess');
		if (!user.isEnabledForSuite && user.hasAccessToArmado) return this.$t('auth.user.tooltip.notEnabledSuite');
		if (!user.isEnabledForSuite && !user.hasAccessToArmado) return this.$t('auth.user.tooltip.noAccessNoSuite');
		return undefined;
	}

	async openUserSelectModalAsync () {
		if (this.props.role) {
			await this.props.role.promptAddRoleUsersAsync(this.showHiddenUser);
		}
		else if (this.props.tag) {
			await this.props.tag.promptUsersToLinkAsync(this.showHiddenUser);
		}
	}

	async removeUserAsync (id: number) {
		if (this.props.role) {
			await this.props.role.deleteRoleUserAsync(id);
		}
		else if (this.props.tag) {
			const targetId = this.props.tag.users.find(x => x.user?.id === id)?.id;
			if (targetId) {
				await this.props.tag.unlinkUserAsync([targetId]);
			}
		}
	}

}
